export interface INavigationRoute {
  name: string
  displayName: string
  meta?: { icon?: string }
  children?: INavigationRoute[]
  permission?: string
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'crm',
      displayName: 'menu.crm',
      meta: {
        icon: 'mso-question_answer',
      },
    },
    {
      name: 'painel',
      displayName: 'menu.painel',
      meta: {
        icon: 'mso-space_dashboard',
      },
    },
    {
      name: 'contato',
      displayName: 'menu.contato',
      meta: {
        icon: 'mso-article',
      },
      children: [
        {
          name: 'cont_list',
          displayName: 'menu.contato',
        },
        {
          name: 'tags-list',
          displayName: 'menu.tags',
        },
      ],
    },
    {
      name: 'cliente',
      displayName: 'menu.client',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'veiculo',
      displayName: 'menu.vehicle',
      meta: {
        icon: 'directions_car',
      },
      children: [
        {
          name: 'v_list',
          displayName: 'menu.available',
        },
        {
          name: 'v_sold',
          displayName: 'menu.sold',
        },
      ],
    },
    {
      name: 'venda',
      displayName: 'menu.sales',
      meta: {
        icon: 'mso-money',
      },
      permission: 'view venda',
      children: [
        {
          name: 've_list',
          displayName: 'menu.sales_list',
        },
        {
          name: 've_create',
          displayName: 'menu.sales_new',
        },
      ],
    },
    {
      name: 'negociacao',
      displayName: 'menu.negociacao',
      meta: {
        icon: 'mso-handshake',
      },
      children: [
        {
          name: 'propostas-list',
          displayName: 'menu.propostas',
        },
        {
          name: 'propostas-kanban',
          displayName: 'menu.kanban',
        },
        {
          name: 'propostas-dashboard',
          displayName: 'menu.dashboard_negociacao',
        },
      ],
    },
    {
      name: 'agenda',
      displayName: 'menu.agenda',
      meta: {
        icon: 'mso-calendar_month',
      },
    },
    {
      name: 'tarefas',
      displayName: 'menu.tarefas',
      meta: {
        icon: 'mso-assignment_turned_in',
      },
    },
    {
      name: 'u_list',
      displayName: 'menu.user',
      meta: {
        icon: 'mso-manage_accounts',
      },
    },
    {
      name: 'e_list',
      displayName: 'menu.company',
      meta: {
        icon: 'mso-store',
      },
      children: [
        {
          name: 'e_list',
          displayName: 'menu.company_overview',
          meta: {
            icon: 'mso-storefront',
          },
        },
        {
          name: 'e_config',
          displayName: 'menu.settings',
          meta: {
            icon: 'mso-settings',
          },
        },
        {
          name: 'bh_list',
          displayName: 'menu.businessHour',
          meta: {
            icon: 'mso-schedule',
          },
        },
        {
          name: 'temp_list',
          displayName: 'menu.template',
          meta: {
            icon: 'mso-description',
          },
        },
        {
          name: 'e_bot',
          displayName: 'menu.bot_atendimento',
          permission: 'view_bot_configuration',
          meta: {
            icon: 'mso-smart_toy',
          },
        },
        {
          name: 'e_storage',
          displayName: 'menu.storage',
          meta: {
            icon: 'mso-storage',
          },
        },
      ],
    },
    {
      name: 'reports',
      displayName: 'menu.reports',
      meta: {
        icon: 'mso-assignment',
      },
      permission: 'reports:access',
      children: [
        {
          name: 'reports-general',
          displayName: 'menu.reports_general',
        },
        {
          name: 'reports-templates',
          displayName: 'menu.reports_templates',
        },
        {
          name: 'reports-executions',
          displayName: 'menu.reports_executions',
        },
      ],
    },
    {
      name: 'oportunidades',
      displayName: 'menu.oportunidades',
      meta: {
        icon: 'mso-business_center',
      },
      children: [
        {
          name: 'oportunidades',
          displayName: 'menu.oportunidades',
        },
        {
          name: 'crm-history',
          displayName: 'menu.history',
        },
        {
          name: 'lead-list',
          displayName: 'menu.lead_list',
        },
      ],
    },
    {
      name: 'demos',
      displayName: 'menu.demos',
      meta: {
        icon: 'mso-code',
      },
      permission: 'ver demos',
      children: [
        {
          name: 'lead-contact-demo',
          displayName: 'menu.leadContactDemo',
          permission: 'ver demo leads',
        },
        {
          name: 'lead-test',
          displayName: 'menu.leadTest',
          permission: 'ver demo testes',
        },
      ],
    },
  ] as INavigationRoute[],
}
